<template>
    <main-header :links="links"></main-header>
    <div class="content">


        <section id="huereka">
            <h2>Huereka MR</h2>
            <statistics-browser app="se.begagnaderymdskepp.HuerekaMR"></statistics-browser>
        </section>

        <section id="huereka-dev">
            <h2>Huereka MR (Development)</h2>
            <statistics-browser app="se.begagnaderymdskepp.HuerekaMR.dev"></statistics-browser>
        </section>


        <section id="logout">
            <button class="btn-large" @click="logout">{{ $t('logout') }}</button>
        </section>

    </div>
    
</template>
<script>
import MainHeader from '@/components/MainHeader.vue';
import StatisticsBrowser from '@/components/StatisticsBrowser.vue';

export default {
    components: {
        MainHeader,
        StatisticsBrowser
    },
    mounted () {
        if (!localStorage.getItem('token')) {
            this.$router.push({name: 'login'});
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('token');
            this.$router.push({name: 'login'});
        }
    },
    data () {
        return {
            links: [
                {href: '#', text:'menu.home'},
                {href: '#huereka', text:'Huereka MR'},
                {href: '#huereka-dev', text:'Huereka MR (Development)'},
                {href: '#logout', text:'logout'},
            ]
        }
    }
}

</script>
<style scoped>
    #logout {
        text-align: center;
        margin: 50px;
    }

</style>
